import React from 'react';
import { PanelType } from './RightAIPane';
import './BottomNav.css';

interface BottomNavProps {
  activePanel: PanelType;
  onPanelToggle: (panel: PanelType) => void;
}

interface NavItem {
  panel: PanelType;
  label: string;
  icon: React.ReactNode;
}

const BottomNav: React.FC<BottomNavProps> = ({ activePanel, onPanelToggle }) => {
  const navItems: NavItem[] = [
    {
      panel: 'chat',
      label: 'Assistant',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 19c-5 0-8-3-8-8s3-8 8-8 8 3 8 8-3 8-8 8z"></path>
          <path d="M15 12h6m-3-3v6"></path>
        </svg>
      ),
    },
    {
      panel: 'notifications',
      label: 'Notifications',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      ),
    },
    {
      panel: 'buy',
      label: 'Buy',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
      ),
    },
    {
      panel: 'sell',
      label: 'Sell',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      ),
    },
  ];

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => (
        <button
          key={item.panel}
          className={`bottom-nav-item ${activePanel === item.panel ? 'active' : ''}`}
          onClick={() => onPanelToggle(item.panel)}
          aria-label={item.label}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;

